import { Injectable } from "@angular/core";

declare let gtag: Function;
declare global {
    interface Window {
        dataLayer: any[];
    }
}

@Injectable({
    providedIn: "root",
})
export class AnalyticsService {
    public suppressNextPageView = false;

    private lastEvent = new Map<string, number>();
    private DEDUPE_MS = 2000;

    constructor() {
        window.dataLayer = window.dataLayer || [];
    }

    trackEvent(name: string, params: any = {}) {
        const key = name + JSON.stringify(params || {});
        const now = Date.now();
        if (this.lastEvent.has(key)) {
            if (now - (this.lastEvent.get(key) || 0) < this.DEDUPE_MS) return;
        }
        this.lastEvent.set(key, now);
        gtag("event", name, params);
    }

    trackPageView(params: {
        page_path: string;
        page_location?: string;
        page_title?: string;
    }) {
        if (this.suppressNextPageView) {
            this.suppressNextPageView = false;
            return;
        }
        const key = "page_view:" + params.page_path;
        const now = Date.now();
        if (
            this.lastEvent.has(key) &&
            now - (this.lastEvent.get(key) || 0) < this.DEDUPE_MS
        ) {
            return;
        }
        this.lastEvent.set(key, now);

        gtag("event", "page_view", {
            page_path: params.page_path,
            page_location: params.page_location ?? location.href,
            page_title: params.page_title ?? document.title,
        });
    }

    onContactScroll(section: string) {
        this.trackEvent("contact_scroll", {
            section,
        });
    }

    onProjectScroll(section: string) {
        this.trackEvent("project_scroll", {
            section,
        });
    }
}
